import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-explanation',
  templateUrl: './payment-explanation.component.html',
  styleUrls: ['./payment-explanation.component.scss']
})
export class PaymentExplanationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
